import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { CanPaperlessPolicyDeactivate } from "../models/CanPaperlessPolicyDeactivate";

@Injectable({
  providedIn: "root",
})
export class PaperlessPolicyDeactivateGuard
  implements CanDeactivate<CanPaperlessPolicyDeactivate>
{
  canDeactivate(
    component: CanPaperlessPolicyDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
